import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';

function MalzemeSearch({ setMalzeme, value, searchParam }) {
    const [openMalzeme, setOpenMalzeme] = React.useState(false);
    const [optionsMalzeme, setOptionsMalzeme] = React.useState([]);
    const loadingMalzeme = openMalzeme && optionsMalzeme.length === 0;
    const [searchMalzeme, setSearchMalzeme] = React.useState('');

    React.useEffect(() => {
        let active = true;
        if (searchMalzeme.length > 0 && openMalzeme) {
            axios.get('/GetArtemisMaterials/' + searchMalzeme.toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    if (active) {
                        if (res.data.length > 0) {
                            setOptionsMalzeme(res.data);
                        } else {
                            setOptionsMalzeme([]);
                        }                        
                    }
                }).catch(error => {
                    setOptionsMalzeme([]);
                    logger.error("Hata detayı:", error.message);
                });
        }
        return () => {
            active = false;
        };
    }, [searchMalzeme, openMalzeme, loadingMalzeme]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setSearchMalzeme(searchParam);
        }
    }, [searchParam]);

    const updateMalzeme = malzeme => {
        setMalzeme(malzeme);
        value.ACIKLAMA = malzeme.ACIKLAMA;
        value.MALZEME_STOK_NO = malzeme.MALZEME_STOK_NO;
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={openMalzeme}
            value={value}
            onOpen={() => {
                setOpenMalzeme(true);
            }}
            onClose={() => {
                setOpenMalzeme(false);
            }}
            getOptionLabel={(option) => { return option.MALZEME_STOK_NO ? (option.MALZEME_STOK_NO + ' - ' + option.ACIKLAMA) : '-' }}
            options={optionsMalzeme}
            filterOptions={(optionsMalzeme) => optionsMalzeme}
            loading={loadingMalzeme}
            onChange={(event, newValueMalzeme) => {
                if (newValueMalzeme && newValueMalzeme.ACIKLAMA) {
                    updateMalzeme(newValueMalzeme);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => { setSearchMalzeme(e.target.value) }}
                    variant="outlined"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loadingMalzeme ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export default MalzemeSearch;
